export default {
    ja: {
        map: {
            heading: 'CONTENTS MAP',
            description: 'タップして拡大できます。',
            image: 'Images/map/nataderaMAP_2025_0924.webp',
        }
    },
    en: {
        map: {
            heading: 'CONTENTS MAP',
            description: 'Tap to enlarge.',
            image: 'Images/map/nataderaMAP_2025_0924.webp',
        }
    },


}